import { ResourceRef } from '../../../common/models/resource-ref.model';
import { MessageType } from '../../common/models/message-type.enum';

export enum MessageStatus {
  Queued = 'queued',
  Sent = 'sent',
  Failed = 'failed',
  Received = 'received',
  DeliverySuccess = 'delivery-success',
  DeliveryFailed = 'delivery-failed',
  Read = 'read'
}

export type ConversationNormalizedMessageStatus = 'Sent' | 'Delivered' | 'Read' | 'Failed' | 'Published' | 'Removed';

export enum MessageDirection {
  Inbound = 'inbound',
  Outbound = 'outbound'
}

export enum ConversationMessageContentType {
  Attachment = 'Attachment',
  Location = 'Location',
  Story = 'Story',
  QuickReply = 'QuickReply',
  Notification = 'Notification',
  ButtonResponse = 'ButtonResponse',
  GenericTemplate = 'GenericTemplate',
  Card = 'Card',
  Carousel = 'Carousel'
}

export enum ConversationMessageEventType {
  Presence = 'Presence',
  CoBrowse = 'CoBrowse'
}

export enum ConversationMessageEventPresenceType {
  Join = 'Join',
  Disconnect = 'Disconnect',
  Clear = 'Clear'
}

export enum ConversationContentAttachmentMediaType {
  Image = 'Image',
  Video = 'Video',
  Audio = 'Audio',
  File = 'File',
  Link = 'Link'
}

export interface MessageData extends ResourceRef {
  conversationId: string;
  direction: MessageDirection;
  textBody: string;
  timestamp: string;
  status: MessageStatus;
  normalizedMessage: ConversationNormalizedMessage;
  normalizedReceipts: ConversationNormalizedMessage[];
  messengerType: MessageType;
}

interface ConversationMessageEventPresence {
  type: ConversationMessageEventPresenceType;
}

export interface ConversationMessageEvents {
  eventType: ConversationMessageEventType;
  presence?: ConversationMessageEventPresence;
}

export interface ConversationNormalizedMessage {
  content?: ConversationMessageContent[];
  events?: ConversationMessageEvents[];
  type?: string;
  status?: ConversationNormalizedMessageStatus;
  isFinalReceipt?: boolean;
  channel?: {
    time?: string;
    to?: {
      additionalIds: { value: string; type: string }[];
    };
  };
}
export interface ConversationMessageContent {
  contentType: ConversationMessageContentType;
  attachment?: ConversationContentAttachment;
  card?: ConversationContentCard;
  carousel?: ConversationContentCarousel;
  buttonResponse?: ConversationContentButtonResponse;
}

export interface ConversationContentAttachment {
  mediaType: ConversationContentAttachmentMediaType;
  id?: string;
  url?: string;
  mime?: string;
  text?: string;
  filename?: string;
}

export interface ConversationContentCard {
  title: string;
  image?: string;
  video?: string;
  description: string;
  defaultAction?: { type: string; url: string; text: string; payload: string };
  actions: ConversationContentButtonResponse[];
}

interface ConversationContentCarousel {
  cards: ConversationContentCard[];
}

interface ConversationContentButtonResponse {
  payload?: string;
  text: string;
  type: ConversationContentButtonResponseType;
}

export type ConversationContentButtonResponseType = 'Button' | 'QuickReply' | 'Postback';
